import React from 'react';
import { ReactComponent as SKU } from './SKUAnalysis.svg';

function SkuSvg() {
	return <SKU width="80pt" height="80pt" />;
}

export default SkuSvg;
